<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">模板</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">模板模板</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">模板模板</div>
      </div>
      <div class="panel-body clearfix">
        <div class="Z-hr"></div>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    components:{

    },
    props:{
      hide:Boolean
    },
    mounted() {

    },
    methods:{

    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
</style>



// WEBPACK FOOTER //
// src/pages/caiwu/master.vue